/**
 * LegacyTooltip - Drop-in replacement for react-bootstrap Tooltip
 *
 * This component provides API compatibility with react-bootstrap's Tooltip.
 * It's used as a container to pass content to CustomOverlayTrigger.
 *
 * The actual tooltip rendering is handled by CustomOverlayTrigger using Radix UI.
 * This component just wraps children so they can be extracted via overlay.props.children.
 */
import React, { PropsWithChildren } from "react";

export interface LegacyTooltipProps extends PropsWithChildren {
  id?: string;
  className?: string;
  style?: React.CSSProperties;
  bsClass?: string;
  placement?: "top" | "bottom" | "left" | "right";
  positionTop?: number | string;
  positionLeft?: number | string;
  arrowOffsetTop?: number | string;
  arrowOffsetLeft?: number | string;
}

/**
 * A minimal Tooltip shim that wraps content for use with CustomOverlayTrigger.
 * The CustomOverlayTrigger extracts children from this component via overlay.props.children.
 */
function LegacyTooltip({ children, className }: LegacyTooltipProps) {
  // Just return the children wrapped in a span for styled-components compatibility
  // The actual tooltip rendering is done by CustomOverlayTrigger
  return <span className={className}>{children}</span>;
}

export default LegacyTooltip;
